import { render, staticRenderFns } from "./Step_v2.vue?vue&type=template&id=8994b42a&scoped=true"
import script from "./Step_v2.vue?vue&type=script&lang=js"
export * from "./Step_v2.vue?vue&type=script&lang=js"
import style0 from "./Step_v2.vue?vue&type=style&index=0&id=8994b42a&prod&lang=css"
import style1 from "./Step_v2.vue?vue&type=style&index=1&id=8994b42a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8994b42a",
  null
  
)

export default component.exports